import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import LayersIcon from '@mui/icons-material/Layers'; // Puedes cambiar el icono por el que prefieras

interface TotalItemsCardProps {
  total: number;
  label?: string; // Opcional, por si quieres cambiar el texto de "Total elementos"
  loading?: boolean; // Opcional, por si está cargando los datos
  icon?: React.ReactNode; // Opcional, por si quieres cambiar el icono
}

export const TotalItemsCard: React.FC<TotalItemsCardProps> = ({ 
  total, 
  label = "Total Elementos",
  loading = false,
  icon = <LayersIcon fontSize="large" />
}) => {
  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: 2, // Bordes redondeados sutiles
        border: '1px solid',
        borderColor: 'divider', // Usa el color de borde por defecto del tema de MUI
        backgroundColor: (theme) => 
          theme.palette.mode === 'dark' ? '#1e1e1e' : '#f8f9fa', // Fondo grisáceo muy limpio
        minWidth: '240px',
        maxWidth: '320px',
      }}
    >
      <Box>
        <Typography 
          variant="subtitle2" 
          color="text.secondary" 
          fontWeight="600"
          textTransform="uppercase"
          letterSpacing={0.5}
        >
          {label}
        </Typography>
        <Typography 
          variant="h3" 
          component="div" 
          fontWeight="bold" 
          color="primary.main"
          sx={{ mt: 0.5 }}
        >
          {loading ? '...' : total}
        </Typography>
      </Box>

      {/* Contenedor del Icono con fondo circular sutil */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 1.5,
          borderRadius: '50%',
          backgroundColor: '#003049',
          //opacity: 0.85,
          color: 'primary.contrastText',
        }}
      >
        {icon}
      </Box>
    </Paper>
  );
};